/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import { ControlFunctionDTO } from './ControlFunctionDTO';
import {LegalEntityCompanyDTO} from './LegalEntityCompanyDTO';
import {LegalEntityParentCompanyDTO} from './LegalEntityParentCompanyDTO';
import {LegalEntitySubsidiaryDTO} from './LegalEntitySubsidiaryDTO';

/**
 * The AuthorityDTO model module.
 * @module model/AuthorityDTO
 * @version v0
 */
export class AuthorityDTO {
  /**
   * Constructs a new <code>AuthorityDTO</code>.
   * @alias module:model/AuthorityDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AuthorityDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AuthorityDTO} obj Optional instance to populate.
   * @return {module:model/AuthorityDTO} The populated <code>AuthorityDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AuthorityDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('legalEntityParentCompany'))
        obj.legalEntityParentCompany = LegalEntityParentCompanyDTO.constructFromObject(data['legalEntityParentCompany']);
      if (data.hasOwnProperty('legalEntitySubsidiary'))
        obj.legalEntitySubsidiary = LegalEntitySubsidiaryDTO.constructFromObject(data['legalEntitySubsidiary']);
      if (data.hasOwnProperty('legalEntityCompany'))
        obj.legalEntityCompany = LegalEntityCompanyDTO.constructFromObject(data['legalEntityCompany']);
        if (data.hasOwnProperty('controlFunction'))
        obj.controlFunction = ControlFunctionDTO.constructFromObject(data['controlFunction']);
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AuthorityDTO.prototype.id = undefined;

/**
 * @member {module:model/LegalEntityParentCompanyDTO} legalEntityParentCompany
 */
AuthorityDTO.prototype.legalEntityParentCompany = undefined;

/**
 * @member {module:model/LegalEntitySubsidiaryDTO} legalEntitySubsidiary
 */
AuthorityDTO.prototype.legalEntitySubsidiary = undefined;

/**
 * @member {module:model/LegalEntityCompanyDTO} legalEntityCompany
 */
AuthorityDTO.prototype.legalEntityCompany = undefined;

/**
 * @member {module:model/ControlFunctionDTO} controlFunction
 */
 AuthorityDTO.prototype.controlFunction = undefined;

/**
 * @member {String} type
 */
AuthorityDTO.prototype.type = undefined;

